import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const LINKS = [
  { id: "about", label: "The Firm" },
  { id: "practice", label: "Practice Areas" },
  { id: "clients", label: "Clients" },
  { id: "fees", label: "Fees & Ethics" },
  { id: "journal", label: "Legal Updates" },
  { id: "contact", label: "Contact" },
];

export default function Header({ onNavigate }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-navy-950/80 backdrop-blur-xl border-b border-gold/20"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[70px] flex items-center justify-between">
        <button
          data-testid="nav-logo-link"
          onClick={() => onNavigate("hero")}
          className="flex items-center gap-3 group"
        >
          <img
            src="/assets/logo.jpg"
            alt="Musesya & Company Advocates seal"
            className="h-10 w-10 rounded-full object-cover ring-1 ring-gold/50 group-hover:ring-gold transition-all duration-300"
          />
          <span className="hidden sm:block font-display text-sm tracking-[0.18em] text-ink">
            MUSESYA <span className="text-gold">&</span> CO.
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => onNavigate(l.id)}
              className="text-sm text-ink-dim hover:text-gold transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="header-consult-button"
          href="tel:+254720577583"
          className="flex items-center gap-2 border border-gold/40 text-gold text-xs sm:text-sm px-4 sm:px-5 py-2.5 rounded-full hover:bg-gold hover:text-navy-950 transition-colors duration-300"
        >
          <Phone size={14} />
          <span className="hidden sm:inline">Consult an Advocate</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </motion.header>
  );
}
